import * as React from "react";

export const columns = (t) => [

    {
        field: "name",
        label: t ? t("common.group_name") : "Nazwa grupy",
        sort: "desc",
        width: 100,
    },
    {
        field: "parametersCount",
        label: t ? t("common.parameters_count") : "Ilość parametrów",
        sort: "desc",
        width: 100,
        type: "custom",
        custom: function (column, row, history) {
            return row.operatingParameterTemplates?.length
        }
    },
];

export default columns;
